import { useImperativeHandle, forwardRef } from 'react'
import classNames from 'classnames'
import './index.scss'

export const Tab = ({ children, className = '' }) => <div className={`tabs__content ${className}`}>{children}</div>

const Tabs = forwardRef(({ activeTab, children, tabStyle, className, tabChangeCallback, tabClickHandler }, ref) => {
    const [isActiveTab, setIsActiveTab] = React.useState(activeTab)

    useImperativeHandle(ref, () => ({
        click: index => onClickHandler(index),
    }))

    const onClickHandler = (index, onClick) => {
        if (tabClickHandler) {
            const result = tabClickHandler()

            if (!result) return
        }

        setIsActiveTab(index)
        tabChangeCallback && tabChangeCallback(index)
        onClick && onClick()
    }

    return (
        <div
            className={classNames('tabs', {
                [`tabs--${tabStyle}`]: !!tabStyle,
                [className]: className,
            })}>
            <ul className={classNames('tabs__nav')}>
                {React.Children.map(children, (child, index) => (
                    <li
                        onClick={() => onClickHandler(index, child.props.onClick)}
                        key={index}
                        className={classNames('tabs__nav-item', {
                            'tabs__nav-item--active': index === isActiveTab,
                        })}>
                        <span className="tabs__nav-label">{child.props.label}</span>
                    </li>
                ))}
            </ul>

            <div className="tabs__content">
                {React.Children.map(children, (child, index) =>
                    index === isActiveTab ? <Tab {...child.props} /> : null
                )}
            </div>
        </div>
    )
})

export default Tabs

Tabs.propTypes = {
    tabStyle: PropTypes.oneOf(['tabs', 'pills']),
    activeTab: PropTypes.number,
    className: PropTypes.string,
}

Tabs.defaultProps = {
    tabStyle: 'tabs',
    activeTab: 0,
}
